module.exports = __webpack_public_path__ + "static/media/bg.2640a48e.png";